import * as React from 'react'

export function ExclamationIcon({
  color = 'red',
}: {
  color: 'red' | 'yellow'
}) {
  const colorValue = {
    red: '#EE3E3A',
    yellow: '#F1A30E',
  }[color]
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M2.16921 55.0675C-4.01833 64.9414 3.90553 76.5134 14.9111 76.5134H65.0879C76.0833 76.5134 84.0203 64.9514 77.8323 55.0683L52.7404 11.8997L52.694 11.8265C46.9216 2.73152 33.0872 2.71745 27.3058 11.8265L27.2594 11.8997L2.16921 55.0675Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        d="M14.9111 76.5134C3.90553 76.5134 -4.01833 64.9414 2.16922 55.0675L27.2594 11.8997L27.3058 11.8265C33.0872 2.71745 46.9216 2.73152 52.694 11.8265L52.7404 11.8997L77.8323 55.0683C84.0203 64.9514 76.0833 76.5134 65.0879 76.5134H14.9111ZM40.0078 53.0833C42.5111 53.0833 44.5489 51.1762 44.5489 48.8333V27.5833C44.5489 25.2405 42.5111 23.3333 40.0078 23.3333C37.5045 23.3333 35.4667 25.2405 35.4667 27.5833V48.8333C35.4667 51.1762 37.5045 53.0833 40.0078 53.0833ZM35.4667 61.5832C35.4667 63.926 37.5045 65.8332 40.0078 65.8332C42.5111 65.8332 44.5489 63.926 44.5489 61.5832C44.5489 59.2403 42.5111 57.3332 40.0078 57.3332C37.5045 57.3332 35.4667 59.2403 35.4667 61.5832Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        d="M48.9464 14.2051L74.0344 57.3672C78.1549 63.8633 73.1573 72.0746 65.0879 72.0746H14.9111C6.83487 72.0746 1.84611 63.8567 5.96667 57.3672L31.0534 14.2051C35.0897 7.84576 44.9156 7.85419 48.9464 14.2051ZM2.16921 55.0675C-4.01833 64.9414 3.90553 76.5134 14.9111 76.5134H65.0879C76.0833 76.5134 84.0203 64.9514 77.8323 55.0683L52.7404 11.8997L52.694 11.8265C46.9216 2.73152 33.0872 2.71745 27.3058 11.8265L27.2594 11.8997L2.16921 55.0675Z"
        fill="white"
      />
    </svg>
  )
}
